import lazyLoading from '../../lazyLoading'



export default [
  // {
  //   path: 'workbench',
  //   meta: {
  //     title: '工作台',
  //     icon: require('@/assets/layout/1-1-2.png'),
  //     activeIcon: require('@/assets/layout/1-2-2.png'),
  //   },
  //   component: lazyLoading('views/workbench/index'),
  //   children: []
  // },
  // {
  //   path: 'editarticle',
  //   meta: {
  //     title: '写文章',
  //     icon: require('@/assets/layout/2-1-2.png'),
  //     activeIcon: require('@/assets/layout/2-2-2.png'),
  //   },
  //   component: lazyLoading('views/editarticle/index'),
  //   children: []
  // },
  // {
  //   path: 'drafts',
  //   meta: {
  //     title: '草稿箱',
  //     icon: require('@/assets/layout/3-1-2.png'),
  //     activeIcon: require('@/assets/layout/3-2-2.png'),
  //   },
  //   component: lazyLoading('views/drafts/index'),
  //   children: []
  // },
  // {
  //   path: 'released',
  //   meta: {
  //     title: '已发布',
  //     icon: require('@/assets/layout/4-1-2.png'),
  //     activeIcon: require('@/assets/layout/4-2-2.png'),
  //   },
  //   component: lazyLoading('views/released/index'),
  //   children: []
  // },
  // {
  //   path: 'userInfo',
  //   component: lazyLoading('views/userInfo/index'),
  //   meta: {
  //     title: '申报中心',
  //     icon:'robot',
  //     activeIcon: 'robot'
  //   },
  //   children: []
  // },
  {
    path: 'declarationCenter',
    component: lazyLoading('views/declarationCenter/index'),
    meta: {
      title: '申报中心',
      icon: 'robot',
      activeIcon: 'robot',
      showFlag:true,
    },
    children: [
      {
        path: '/skl/declarationCenter/projectDeclaration',
        meta: {
          title: '项目申报',
          chooseKey:0,
        },
        component: () => import('@/views/declarationCenter/projectDeclaration/index.vue'),
      },
      // {
      //   path: '/skl/declarationCenter/baseDeclaration',
      //   meta: {
      //     title: '基地申报',
      //     chooseKey:1,
      //   },
      //   component: () => import('@/views/declarationCenter/baseDeclaration/index.vue'),
      // },
      {
        path: '/skl/declarationCenter/baseReview',
        meta: {
          title: '基地复评',
          chooseKey:2,
        },
        component: () => import('@/views/declarationCenter/baseReview/index.vue'),
      },
      {
        path: '/skl/declarationCenter/basePublicize',
        meta: {
          title: '基地信息填报',
          chooseKey:9,
        },
        component: () => import('@/views/declarationCenter/basePublicize/index.vue'),
      },
    ]
  },
  {
    path: 'auditCenter',
    component: lazyLoading('views/auditCenter/index'),
    meta: {
      title: '审核中心',
      icon: 'robot',
      activeIcon: 'robot',
      showFlag:true,
    },
    children: [
      {
        path: '/skl/auditCenter/projectDeclaration',
        meta: {
          title: '项目申报',
          chooseKey:3,
        },
        component: () => import('@/views/auditCenter/projectDeclaration/index.vue'),
      },
      {
        path: '/skl/auditCenter/baseDeclaration',
        meta: {
          title: '基地申报',
          chooseKey:4,
        },
        component: () => import('@/views/auditCenter/baseDeclaration/index.vue'),
      },
      {
        path: '/skl/auditCenter/baseReview',
        meta: {
          title: '基地复评',
          chooseKey:5,
        },
        component: () => import('@/views/auditCenter/baseReview/index.vue'),
      },
      {
        path: '/skl/auditCenter/basePublicize',
        meta: {
          title: '基地信息填报',
          chooseKey:10,
        },
        component: () => import('@/views/auditCenter/basePublicize/index.vue'),
      },
    ]
  },
  {
    path: 'expertReview',
    component: lazyLoading('views/expertReview/index'),
    meta: {
      title: '专家评审',
      icon: 'robot',
      activeIcon: 'robot',
      showFlag:true,
    },
    children: [
      {
        path: '/skl/expertReview/projectDeclaration',
        meta: {
          title: '项目申报',
          chooseKey:6,
        },
        component: () => import('@/views/expertReview/projectDeclaration/index.vue'),
      },
      {
        path: '/skl/expertReview/baseDeclaration',
        meta: {
          title: '基地申报',
          chooseKey:7,
        },
        component: () => import('@/views/expertReview/baseDeclaration/index.vue'),
      },
      {
        path: '/skl/expertReview/baseReview',
        meta: {
          title: '基地复评',
          chooseKey:8,
        },
        component: () => import('@/views/expertReview/baseReview/index.vue'),
      },
    ]
  },
]
